// src/lib/kinema/core/history/History.ts
import type { InverseOperation } from '../types';

type HistoryEntry = InverseOperation[];

export class History {
  private undoStack: HistoryEntry[] = [];
  private redoStack: HistoryEntry[] = [];

  pushUndo(inverses: InverseOperation[], clearRedo = true): void {
    if (inverses.length === 0) return;
    this.undoStack.push(inverses);
    if (clearRedo) this.redoStack = [];
  }

  pushRedo(inverses: InverseOperation[]): void {
    if (inverses.length === 0) return;
    this.redoStack.push(inverses);
  }

  popUndo(): InverseOperation[] | null {
    const entry = this.undoStack.pop();
    return entry ?? null;
  }

  popRedo(): InverseOperation[] | null {
    const entry = this.redoStack.pop();
    return entry ?? null;
  }

  canUndo(): boolean {
    return this.undoStack.length > 0;
  }

  canRedo(): boolean {
    return this.redoStack.length > 0;
  }

  clear(): void {
    this.undoStack = [];
    this.redoStack = [];
  }
}
